// ABOUTME: Main page for external channels management in relation portal
// ABOUTME: Displays list of external channels for the relation with TabView3 layout

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";
import All from "./Views/All";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { relationSettingsExternalChannelsConfig } from "./relationSettingsExternalChannelsConfig";
import { useTranslation } from "react-i18next";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import { useEffect } from "react";

const RelationSettingsExternalChannels = () => {
    const { t, ready, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { showExtraTitle, clearExtraTitle } = useTopbar();

    useEffect(() => {
        showExtraTitle(t("external_channels"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle, clearExtraTitle, t, i18n.language])

    return (
        <Box
            sx={{
                background: "",
                width: 1,
                paddingTop: 9,
                position: "relative",
                "@media screen and (max-width:47.9375em)": {
                    background: "",
                    width: 1,
                    marginTop: 9,
                    height: "calc(100% - 72px)",
                    paddingX: 4,
                    paddingTop: 0,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                },
                "@media screen and (max-width: 47.9375em)": {
                    paddingX: 0,
                    background: colors.bg["tertiary"],
                    "&:before,&:after": {
                        display: "none"
                    }
                },
            }}
        >
            <TabView3
                tabConfig={relationSettingsExternalChannelsConfig}
                sx={{
                    background: "green",
                    minHeight: "calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    "&:before": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "32px",
                        position: "absolute",
                        left: 0,
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms"
                    },
                    "&:after": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "32px",
                        position: "absolute",
                        top: "40px",
                        zIndex: 1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        right: 0,
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms"
                    },
                    "@media screen and (max-width: 47.9375em)": {
                        "&:before, &:after": {
                            top: 0,
                        }
                    }
                }}
            >
                <>
                    <All config={relationSettingsExternalChannelsConfig.all} />
                </>
            </TabView3>
        </Box>
    )
};

export default RelationSettingsExternalChannels;
